import styled from "styled-components";

const NavyGrad = "linear-gradient(0deg, #000000, #0C122F, #0C132F)";
const GoldGrad = "linear-gradient(90deg, #0C132F -70%, #B8860F, #ffc107 100%)";

export const Styles = styled.div`
  /* Utility Row - High Z-index to prevent clipping */
  .top-utility-row {
    background: ${NavyGrad};
    height: 40px;
    font-size: 13px;
    color: #e2e8f0;
    position: relative;
    z-index: 1100; /* Highest layer for dropdowns */
    border-bottom: 1px solid rgba(255,255,255,0.05);

    .contact-links i { color: #ffc107; margin-right: 5px; }
    
    .social-box a {
      color: #e2e8f0;
      margin-right: 12px;
      transition: 0.3s;
      &:hover { color: #ffc107; }
    }

    /* Language Selection Fix */
    .lang-selector-modern {
      .dropdown-toggle {
        color: #fff;
        font-weight: 400;
        font-size: 13px;
        padding: 0;
        &:after { display: none; }
        i { color: #ffc107; font-size: 16px; }
      }
      .dropdown-menu {
        background: #fff;
        border: none;
        box-shadow: 0 10px 30px rgba(0,0,0,0.2);
        border-radius: 8px;
        margin-top: 10px;
        z-index: 2000;
        
        .dropdown-item {
          padding: 8px 20px;
          font-weight: 500;
          &:hover { background: #f7fafc; color: #B8860F; }
          &.active-lang { color: #ffc107; background: #0c132f; }
        }
      }
    }

    .auth-link {
      color: #fff;
      text-decoration: none;
      font-weight: 400;
      i { color: #ffc107; font-size: 18px; }
    }
  }

  /* Main Nav - Floating Logo Effect */
  .main-nav-row {
    background: rgba(255, 255, 255, 0.98);
    height: 90px;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 25px rgba(0,0,0,0.05);
    position: relative;
    z-index: 1000;

    .nav-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    /* BIG FLOATING LOGO SHIELD */
    .floating-branding {
      position: relative;
      z-index: 1050;
      margin-top: -10px;
      
      a {
        display: flex;
        align-items: center;
        text-decoration: none;
      }

      .logo-shield {
        background: #fff;
        padding: 5px;
        border-radius: 0 0 50px 50px; /* Shield Shape */
        box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        width: 130px; /* Big Logo Wrapper */
        height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: -25px; /* Floats above the header */
        border: 1px solid #ffc107;
        
        img {
          width: 150%;          
          height: auto;
        }
      }

      .logo-text {
        margin-left: 145px; /* Offset for the shield */
        .brand-gradient {
          background: ${GoldGrad};
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-family: 'Rajdhani', sans-serif;
          font-weight: 800;
          font-size: 2.2rem;
          margin: 0;
          line-height: 1;
        }
        p {
          font-size: 10px;
          font-weight: 700;
          color: #4a5568;
          letter-spacing: 2px;
          margin: 0;
        }
      }
    }

    /* Navigation Menu */
    .nav-menu-list {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        position: relative;
        padding: 10px 15px;
        
        a {
          color: #0c132f;
          font-weight: 700;
          font-size: 14px;
          text-transform: uppercase;
          text-decoration: none;
          transition: 0.3s;
          &:hover { color: #B8860F; }
        }

        .sub-menu {
          position: absolute;
          top: 100%;
          left: 0;
          background: #fff;
          min-width: 240px;
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
          border-radius: 0 0 10px 10px;
          border-top: 3px solid #B8860F;
          list-style: none;
          padding: 10px 0;
          opacity: 0;
          visibility: hidden;
          transform: translateY(15px);
          transition: 0.3s;

          li a {
            padding: 10px 20px;
            display: block;
            font-size: 13px;
            text-transform: capitalize;
            &:hover { background: #f8f9fa; padding-left: 25px; }
          }
        }
        /* Apply this to the Courses <ul> (sub-menu) */
        .grid-menu {
          min-width: 550px;              /* Width for two columns */
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          padding: 20px !important;
          gap: 5px;

          li {
            width: 100%;
            padding: 0 !important;       /* Reset parent padding for grid */
            
            a {
              padding: 12px 20px !important;
              border-bottom: none !important; /* Remove lines between grid items */
              border-radius: 6px;
              display: block;
              
              &:hover {
                background: #f8f9fa;
                padding-left: 25px !important;
                color: #B8860F !important;
              }
            }
          }
        }

        &:hover .sub-menu {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        &.dashboard-highlight a {
          color: #B8860F;
          position: relative;
          &:after {
            content: 'Active';
            position: absolute;
            top: -12px;
            right: -10px;
            font-size: 8px;
            background: #ffc107;
            color: #000;
            padding: 2px 5px;
            border-radius: 4px;
          }
        }
      }
    }

    .action-meta {
      display: flex;
      align-items: center;
      gap: 20px;

      .notif-icon {
        font-size: 26px;
        color: #0c132f;
        position: relative;
        .count-badge {
          position: absolute;
          top: -5px;
          right: -5px;
          background: #db5565;
          color: #fff;
          font-size: 10px;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          display: grid;
          place-items: center;
          font-weight: 800;
        }
      }

      .cta-btn-gold {
        background: ${GoldGrad};
        color: #fff;
        padding: 12px 25px;
        border-radius: 50px;
        font-weight: 800;
        font-size: 13px;
        text-transform: uppercase;
        text-decoration: none;
        box-shadow: 0 8px 20px rgba(184, 134, 15, 0.2);
        &:hover { transform: translateY(-2px); box-shadow: 0 10px 25px rgba(184, 134, 15, 0.3); }
      }
    }
  }

   /* --- ACTION META (Notifications & Sidebar) --- */
    /* --- PREVENT OVERFLOW & FIX ALIGNMENT --- */
.action-meta {
  display: flex;
  align-items: center;
  gap: 20px; /* Reduced gap from 30px to prevent pushing off-screen */

  /* ANNOUNCEMENT WRAPPER */
  .notif-wrapper {
    position: relative;
    padding-bottom: 5px; /* Creates a hover bridge */

    .notif-trigger {
      font-size: 28px;
      color: #0c132f;
      cursor: pointer;
      position: relative;
      display: flex;
      align-items: center;

      .count-badge {
        background: #e53e3e;
        font-size: 10px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        position: absolute;
        top: -5px;
        right: -5px;
        display: grid;
        place-items: center;
        color: #fff;
        font-weight: 900;
        border: 2px solid #fff;
      }
    }

    /* HOVER TRIGGER */
    &:hover .announcement-drop {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }

    .announcement-drop {
      display: block;
      position: absolute;
      top: 100%;
      right: -10px; /* Aligned slightly inward to prevent going off-screen */
      width: 300px;  /* Changed from min-width to fixed width */
      background: #fff;
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
      border-radius: 12px;
      border-top: 5px solid #B8860F;
      padding: 0;
      margin-top: 10px;
      opacity: 0;
      visibility: hidden;
      transform: translateY(15px);
      transition: all 0.3s ease-in-out;
      list-style: none;
      z-index: 3000;

      /* Prevent dropdown from going off the left side on very small laptops */
      @media (max-width: 1200px) {
        right: -50px;
      }

      .drop-header {
        padding: 12px 20px;
        background: #f8f9fa;
        font-weight: 800;
        color: #0c132f;
        font-size: 12px;
        text-transform: uppercase;
        border-radius: 12px 12px 0 0;
        border-bottom: 1px solid #eee;
      }

      li {
        padding: 12px 20px;
        border-bottom: 1px solid #f1f1f1;
        cursor: pointer;
        
        .anno-title { font-weight: 700; color: #333; font-size: 13px; display: block; line-height: 1.3; }
        .anno-date { font-size: 11px; color: #999; margin-top: 4px; display: block; }
        
        &:hover { background: #fffcf5; .anno-title { color: #B8860F; } }
        &:last-child { border-bottom: none; border-radius: 0 0 12px 12px; }
      }
    }
  }

  /* BUTTON STYLES */
  .cta-btn-gold {
    background: ${GoldGrad};
    color: #fff !important;
    padding: 10px 22px; /* Smaller padding for better fit */
    border-radius: 50px;
    font-weight: 800;
    font-size: 12px;
    text-transform: uppercase;
    text-decoration: none;
    white-space: nowrap; /* Prevents text from wrapping inside button */
    transition: 0.3s;
    &:hover { transform: translateY(-2px); }
  }

  /* SIDEBAR ICON */
  .sidebar-toggle-wrapper {
    display: flex;
    align-items: center;
    .tnpa-bell {
      color: #0c132f !important;
      font-size: 30px !important;
      cursor: pointer;
      &:hover { color: #B8860F !important; }
    }
  }
}

  /* News Ticker Bar */
  .ticker-row {
    background: #0C132F;
    height: 38px;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 900;

    .ticker-container {
      display: flex;
      align-items: center;
      width: 100%;

      .ticker-label {
        background: #ffc107;
        color: #000;
        padding: 0 25px;
        font-weight: 900;
        font-size: 11px;
        text-transform: uppercase;
        height: 38px;
        display: flex;
        align-items: center;
        clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);
      }

      .ticker-msg {
        color: #fff;
        font-size: 13px;
        padding-left: 30px;
        .sep { color: #ffc107; margin: 0 15px; }
      }
    }
  }

  @media (max-width: 778px) {
    .desktop-only { display: none !important; }
  }
`;